export default function cleanCode(data) {
    return data.replace(/\n/g, ' ').trim() // strip newlines
        .replace(/^json /, '') // replace 'json ' at the start of the string with ''
        .replace(/(?<=^|\s)(".*?"|'.*?')|^\s+|\s+$|\s(?=\s)/g, '$1'); // strip whitespace outside of quotes
}
